import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../config/firebaseClient';
import { GetGlobalQueriesResponse } from '../../functions/src/callable/search/getGlobalQueries.f';

import {
  AddSearchQueryParams,
  AddSearchQueryResponse,
} from '../../functions/src/callable/search/addSearchQuery.f';
export type { AddSearchQueryParams, AddSearchQueryResponse };

import {
  HandleLikeParams,
  HandleLikeResponse,
} from '../../functions/src/callable/like/handleLike.f';
export type { HandleLikeParams, HandleLikeResponse };

import {
  UpdateSelectedItemsParams,
  UpdateSelectedItemsResponse,
} from '../../functions/src/callable/inventory/updateSelectedItems.f';
export type { UpdateSelectedItemsParams, UpdateSelectedItemsResponse };

import {
  PageSearchParams,
  PageSearchResponse,
} from '../../functions/src/callable/search/pageSearch.f';
export type { PageSearchParams, PageSearchResponse };

import {
  OnWeb3SignInParams,
  OnWeb3SignInResponse,
} from '../../functions/src/callable/moralis/onWeb3SignIn.f';
export type { OnWeb3SignInParams, OnWeb3SignInResponse };

import {
  UpdateCurrentGameParams,
  UpdateCurrentGameResponse,
} from '../../functions/src/callable/realtime/updateCurrentGame.f';
export type { UpdateCurrentGameParams, UpdateCurrentGameResponse };

import {
  SendFriendRequestParams,
  SendFriendRequestResponse,
} from 'functions/src/callable/user/sendFriendRequest.f';
export type { SendFriendRequestParams, SendFriendRequestResponse };

import {
  AcceptFriendRequestParams,
  AcceptFriendRequestResponse,
} from 'functions/src/callable/user/acceptFriendRequest.f';
export type { AcceptFriendRequestParams, AcceptFriendRequestResponse };

import {
  DenyFriendRequestParams,
  DenyFriendRequestResponse,
} from 'functions/src/callable/user/denyFriendRequest.f';
export type { DenyFriendRequestParams, DenyFriendRequestResponse };

import {
  CancelFriendRequestParams,
  CancelFriendRequestResponse,
} from 'functions/src/callable/user/cancelFriendRequest.f';
export type { CancelFriendRequestParams, CancelFriendRequestResponse };

import {
  UpdateFavouriteGameParams,
  UpdateFavouriteGameResponse,
} from 'functions/src/callable/user/updateFavouriteGame.f';
export type { UpdateFavouriteGameParams, UpdateFavouriteGameResponse };

import { CreateDummyGameParams } from 'functions/src/callable/tournament/util/createDummyGame.f';
export type { CreateDummyGameParams };

import { CreateDummyTournamentParams } from 'functions/src/callable/tournament/util/createDummyTournament.f';
export type { CreateDummyTournamentParams };

import { CreateTeamParams } from './tournament/createTeam';
export type { CreateTeamParams };

import {
  FillDummyTournamentParams,
  FillDummyTournamentResponse,
} from 'functions/src/callable/tournament/util/fillDummyTournament.f';
export type { FillDummyTournamentParams, FillDummyTournamentResponse };

export const updateFavouriteGame = httpsCallable<
  UpdateFavouriteGameParams,
  UpdateFavouriteGameResponse
>(firebaseFunctions, 'callable-user-updateFavouriteGame');

export const cancelFriendRequest = httpsCallable<
  CancelFriendRequestParams,
  CancelFriendRequestResponse
>(firebaseFunctions, 'callable-user-cancelFriendRequest');

export const sendFriendRequest = httpsCallable<
  SendFriendRequestParams,
  SendFriendRequestResponse
>(firebaseFunctions, 'callable-user-sendFriendRequest');

export const acceptFriendRequest = httpsCallable<
  AcceptFriendRequestParams,
  AcceptFriendRequestResponse
>(firebaseFunctions, 'callable-user-acceptFriendRequest');

export const denyFriendRequest = httpsCallable<
  DenyFriendRequestParams,
  DenyFriendRequestResponse
>(firebaseFunctions, 'callable-user-denyFriendRequest');

export const updateCurrentGame = httpsCallable<
  UpdateCurrentGameParams,
  UpdateCurrentGameResponse
>(firebaseFunctions, 'callable-realtime-updateCurrentGame');

export const requestMessage = httpsCallable(
  firebaseFunctions,
  'callable-moralis-requestMessage',
);

// export const executeFunction = httpsCallable<
//   ExecuteFunctionParams,
//   ExecuteFunctionResponse
// >(firebaseFunctions, 'callable-moralis-executeFunction');

export const getGlobalQueries = httpsCallable<
  undefined,
  GetGlobalQueriesResponse
>(firebaseFunctions, 'callable-search-getGlobalQueries');

export const addSearchQuery = httpsCallable<
  AddSearchQueryParams,
  AddSearchQueryResponse
>(firebaseFunctions, 'callable-search-addSearchQuery');

export const handleLike = httpsCallable<HandleLikeParams, HandleLikeResponse>(
  firebaseFunctions,
  'callable-like-handleLike',
);

export const updateSelectedItems = httpsCallable<
  UpdateSelectedItemsParams,
  UpdateSelectedItemsResponse
>(firebaseFunctions, 'callable-inventory-updateSelectedItems');

export const pageSearch = httpsCallable<PageSearchParams, PageSearchResponse>(
  firebaseFunctions,
  'callable-search-pageSearch',
);

export const onWeb3SignIn = httpsCallable<
  OnWeb3SignInParams,
  OnWeb3SignInResponse
>(firebaseFunctions, 'callable-moralis-onWeb3SignIn');

export const createDummyGame = httpsCallable<
  CreateDummyGameParams,
  Promise<void | { error: string }>
>(firebaseFunctions, 'callable-tournament-util-createDummyGame');

export const createDummyTournament = httpsCallable<
  CreateDummyTournamentParams,
  Promise<void | { error: string }>
>(firebaseFunctions, 'callable-tournament-util-createDummyTournament');

export const createTeam = httpsCallable<
  CreateTeamParams,
  Promise<void | { error: string }>
>(firebaseFunctions, 'callable-tournament-util-createTeam');

export const fillDummyTournament = httpsCallable<
  FillDummyTournamentParams,
  FillDummyTournamentResponse
>(firebaseFunctions, 'callable-tournament-util-fillDummyTournament');
